export default __webpack_public_path__ + "static/media/IMdownload.3fd70839.png";